const DOCUMENT = 'TEMP_MAPBOX';

export const TEMP_GET_ROUTE_DATA = `${DOCUMENT}_GET_ROUTE_DATA`;
export const TEMP_GET_ROUTE_DATA_SUCCESS = `${DOCUMENT}_GET_ROUTE_DATA_SUCCESS`;
export const TEMP_GET_ROUTE_DATA_ERROR = `${DOCUMENT}_GET_ROUTE_DATA_ERROR`;
export const TEMP_CLEAR_MAPBOX_INFO = `${DOCUMENT}_CLEAR_MAPBOX_INFO`;
export const TEMP_SET_ROUTE_DATA = `${DOCUMENT}_TEMP_SET_ROUTE_DATA`;
export const TEMP_SET_ROUTE_DATA_SUCCESS = `${DOCUMENT}_TEMP_SET_ROUTE_DATA_SUCCESS`;
